// extracted by mini-css-extract-plugin
module.exports = {"pitch-animation":"PitchAnimation-PitchAnimationScreen-pitch-animation-31hGUFYp","pitchAnimation":"PitchAnimation-PitchAnimationScreen-pitch-animation-31hGUFYp"};